"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialListProvider = void 0;
const material_list_dialogs_provider_1 = require("./material-list-dialogs.provider");
class MaterialListProvider extends material_list_dialogs_provider_1.MaterialListDialogsProvider {
}
exports.MaterialListProvider = MaterialListProvider;
